import screenshot from "../img/drill-screenshot.png"
import "./Heading.css"

interface HeadingProps {
  handleStageChange: (e: E) => void
}

const Heading = (props: HeadingProps) => {
  return (
    <div className='Heading'>
      <div className='container mt-5'>
        <div className='row'>
          <div className='col text-center'>
            <h1 className='display-4'>
              Red <span id='alertRed'>Alert</span> - Drill
            </h1>
            <div className='col-lg-6 mx-auto'>
              <p className='lead mb-4'>Test your major incident response with this free tabletop exercise tool</p>
              <div className='container'>
                <div className='row d-flex justify-content-center'>
                  <div className='col col-md-8 col-lg-12 col-xl-8'>
                    {/* <div className="w-100"> */}
                    <ul className='text-start'>
                      <li>Completely free to use</li>
                      <li>No signup or email address required</li>
                      <li>Choose from a range of scenarios or come up with your own</li>
                      <li>Review and improve so you're ready for the real thing!</li>
                    </ul>
                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div className='d-grid gap-2 d-sm-flex justify-content-sm-center mb-5'>
                <a className='btn RA-btn btn-lg px-4 me-sm-3' href='#FormHeading'>
                  Let's go
                </a>
              </div>

              <div className='container px-5 mb-5'>
                <img
                  src={screenshot}
                  className='img-fluid border rounded shadow-lg mb-4'
                  alt='Red Alert dashboard'
                  width='700'
                  height='500'
                  loading='lazy'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-alert-blue'>
        <div className='container px-4 py-5' id='icon-grid'>
          <h2 className='pb-2 border-bottom'>How it works:</h2>

          <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 py-5'>
            <div className='col d-flex align-items-start'>
              <span
                className='material-symbols-outlined bi alert-white flex-shrink-0 me-3'
                style={{ fontSize: "2rem" }}
              >
                check_circle
              </span>
              <div>
                <h4 className='fw-bold mb-0'>Choose a scenario</h4>
                <p>
                  Come up with a scenario that could occur at your organisation, or get inspiration from one of the
                  prepopulated scenarios.
                </p>
              </div>
            </div>
            <div className='col d-flex align-items-start'>
              <span
                className='material-symbols-outlined bi alert-white flex-shrink-0 me-3'
                style={{ fontSize: "2rem" }}
              >
                check_circle
              </span>
              <div>
                <h4 className='fw-bold mb-0'>Assign your team</h4>
                <p>Decide who will take part in the exercise and what roles each person will take.</p>
              </div>
            </div>
            <div className='col d-flex align-items-start'>
              <span
                className='material-symbols-outlined bi alert-white flex-shrink-0 me-3'
                style={{ fontSize: "2rem" }}
              >
                check_circle
              </span>
              <div>
                <h4 className='fw-bold mb-0'>Run your exercise</h4>
                <p>
                  Take your team through the scenario and gather insight on the challenges and opportunities you face.
                </p>
              </div>
            </div>
            <div className='col d-flex align-items-start'>
              <span
                className='material-symbols-outlined bi alert-white flex-shrink-0 me-3'
                style={{ fontSize: "2rem" }}
              >
                check_circle
              </span>
              <div>
                <h4 className='fw-bold mb-0'>Review the results</h4>
                <p>Review how the exercise went and what can be improved for when a real incident occurs.</p>
              </div>
            </div>
            <div className='col d-flex align-items-start'>
              <span
                className='material-symbols-outlined bi alert-white flex-shrink-0 me-3'
                style={{ fontSize: "2rem" }}
              >
                lock
              </span>
              <div>
                <h4 className='fw-bold mb-0'>Private</h4>
                <p>The exercise runs on your browser and no data leaves your computer.</p>
              </div>
            </div>
            <div className='col d-flex align-items-start'>
              <span
                className='material-symbols-outlined bi alert-white flex-shrink-0 me-3'
                style={{ fontSize: "2rem" }}
              >
                psychology
              </span>
              <div>
                <h4 className='fw-bold mb-0'>Engaging</h4>
                <p>Engage the whole team in collaborative thinking and problem solving.</p>
              </div>
            </div>
            <div className='col d-flex align-items-start'>
              <span
                className='material-symbols-outlined bi alert-white flex-shrink-0 me-3'
                style={{ fontSize: "2rem" }}
              >
                celebration
              </span>
              <div>
                <h4 className='fw-bold mb-0'>Fun</h4>
                <p>
                  Preparation for major incidents doesn't have to be boring. Keep it light hearted and entertaining.
                </p>
              </div>
            </div>
            <div className='col d-flex align-items-start'>
              <span
                className='material-symbols-outlined bi alert-white flex-shrink-0 me-3'
                style={{ fontSize: "2rem" }}
              >
                school
              </span>
              <div>
                <h4 className='fw-bold mb-0'>Educational</h4>
                <p>
                  Learn where your shortcomings are as a team and give context to any improvements implemented to your
                  processes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Heading
